"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ordering: {
        isLegacyOrderingOnline: 'legacy-ordering-online',
        isGuestOrderingEnabled: 'orderingPortalGuestOrderingEnabled',
        isMultiOrderDateChangeEnabled: 'mav1446MultiOrderDateChange',
        isMultiOrderFastOrderFixEnabled: 'mav1240MultiOrderFastOrderFix',
    },
    services: {
        isLegacyServicesOnline: 'legacy-services-online',
    },
    supplierService: {
        enableItemsSummaryReportV2: 'faas-item-summary-report-v2-enabled',
        enableItemsReportByOrderIdsV2: 'faas-items-report-foom-v2-enabled',
        enableClassReportFoomV2: 'faas-class-report-foom-v2-enabled',
        enableItemsSummaryReportWithoutOrderIds: 'faas-item-summary-report-woi-enabled',
        supplierPortalAutomaticNotificationEnabled: 'supplier-portal-automatic-notification-enabled',
        isEventCreationDatesStreamliningEnabled: 'eventCreationDatesStreamliningEnabled',
        removeFeeSectionForActiveServicePopUpEnabled: 'TGSSP-2180-remove-fee-activate-service-popup',
        isHardRefreshOnIntervalEnabled: 'supplier-portal-faas-hard-page-refresh-on-interval',
    },
    userPortal: {
        isOrderFoodDetanglingEnabled: 'mav582IsOrderFoodDetanglingEnabled',
        isStudentScreenRebuildEnabled: 'te24StudentScreenRebuild',
        isTermsAndConditionsCheckEnabled: 'MAV-1460-IsTermsAndConditionsCheckEnabled',
        isStudentLoginScreenEnabled: 'mav1535StudentLoginScreenEnabled',
        isScheduledReminderNotificationsEnabled: 'mav2606ScheduledReminderNotificationsEnabled',
    },
    items: {
        createItemEnabled: 'create-item-enabled',
        updateQuantitySellLimitOnItems: 'supplier-portal-update-quantity-sell-limit-on-items',
        editItemOptions: 'supplier-portal-edit-item-options',
        editQSLOnOptions: 'supplier-portal-update-quantity-sell-limit-on-options',
    },
    flexiBuzz: {
        supplierPortalParentNotificationsEnabled: 'supplier-portal-parent-notifications-enabled',
    },
    supplierGuestOrdering: {
        supplierPortalGuestOrderingEnabled: 'supplier-portal-guest-ordering-enabled',
        supplierPortalEventServiceDescriptionEnabled: 'supplier-portal-event-service-description-enabled',
    },
    supplierClassUpdates: {
        supplierPortalEditClassListEnabled: 'supplier-portal-edit-class-list-enabled',
    },
};
//# sourceMappingURL=FeatureFlagList.js.map